/**
 * What a job cost, as opposed to what it charged.
 *
 * The billing side of the system already has one arithmetic — `totals.ts` —
 * and it is the customer's. This is the other one, and it is the company's:
 * supplier prices, subcontractor hours, the discount the wholesaler gave. It
 * never reaches an invoice, a customer status page or an email.
 *
 * It lives here rather than on the job page for the reason everything else in
 * this package does: the moment a report wants margin by technician, it has to
 * get the same number the job page shows, and a second implementation is how
 * two screens end up disagreeing about whether a job made money.
 */
/** One line's cost, rounded the same way a line item's price is. */
export function costLineTotal(line) {
    return Math.round(line.unitCostCents * line.quantity);
}
export function jobCosting(input) {
    const grossCostCents = input.items.reduce((sum, line) => sum + costLineTotal(line), 0);
    // A discount cannot make a job cost less than nothing, and cannot exceed
    // what was spent — either would quietly inflate the margin.
    const internalDiscountCents = Math.min(Math.max(input.internalDiscountCents ?? 0, 0), grossCostCents);
    const netCostCents = grossCostCents - internalDiscountCents;
    const billed = input.billedTotalCents ?? null;
    const marginCents = billed === null ? null : billed - netCostCents;
    // Guarded rather than merely non-null: a zero-value job has no meaningful
    // percentage, and dividing by it would put Infinity on the screen.
    const marginBps = billed === null || billed === 0 ? null : Math.round((marginCents / billed) * 10_000);
    return { grossCostCents, internalDiscountCents, netCostCents, marginCents, marginBps };
}
//# sourceMappingURL=costing.js.map